<template>
  <div class="card" :style="styleObj">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    styleObj: {
      type: Object,
      default: {}
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/resuables/card.vue